import { render, staticRenderFns } from "./DraftBlockingOverlay.vue?vue&type=template&id=c00b8e14&"
import script from "./DraftBlockingOverlay.vue?vue&type=script&lang=js&"
export * from "./DraftBlockingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports